import { Module } from '@nestjs/common';
import { ConfigModule, ConfigService } from '@nestjs/config';
import { JwtModule } from '@nestjs/jwt';
import { PassportModule } from '@nestjs/passport';
import { EmpresasModule } from 'src/empresas/empresas.module';
import { PrismaModule } from 'src/prisma/prisma.module';
import { QueuesModule } from 'src/queues/queues.module';
import { RedisModule } from 'src/redis/redis.module';
import { RubrosModule } from 'src/rubros/rubros.module';
import { SuscripcionesModule } from 'src/suscripciones/suscripciones.module';
import { winstonConfig } from '../common/logger/winston.config';
import { AuthController } from './auth.controller';
import { AuthService } from './auth.service';
import { JwtStrategy } from './jwt.strategy';
import { UserEmpresasController } from './user-empresas.controller';
import { UserEmpresasService } from './user-empresas.service';

@Module({
  imports: [
    ConfigModule,
    PassportModule,
    JwtModule.registerAsync({
      inject: [ConfigService],
      useFactory: (config: ConfigService) => {
        const expiresInEnv = Number(config.get('JWT_EXPIRES_IN'));
        const expiresIn = Number.isFinite(expiresInEnv) && expiresInEnv > 0 ? expiresInEnv : 60 * 60 * 24;
        return {
          secret: config.get<string>('JWT_SECRET') ?? 'dev-secret',
          signOptions: { expiresIn },
        };
      },
    }),
    PrismaModule,
    RedisModule,
    QueuesModule,
    EmpresasModule,
    SuscripcionesModule,
    RubrosModule,
  ],
  controllers: [AuthController, UserEmpresasController],
  providers: [AuthService, JwtStrategy, UserEmpresasService],
  exports: [AuthService],
})
export class AuthModule {}
